"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICondition = exports.IValueOperator = exports.ICarrierContext = exports.IDateContext = exports.IEventOperator = exports.ILogicOperator = exports.IDataOperator = exports.EventOpConditionalField = exports.DataOperatorType = exports.ConditionalOperations = void 0;
const openapi_1 = require("../../../openapi");
const IChargeMethod_1 = require("./IChargeMethod");
const IChargeTier_1 = require("./IChargeTier");
const IUomChargeMethod_1 = require("./IUomChargeMethod");
var ConditionalOperations;
(function (ConditionalOperations) {
    ConditionalOperations["noop"] = "noop";
    ConditionalOperations["equal"] = "equal";
    ConditionalOperations["notEqual"] = "notequal";
    ConditionalOperations["greaterThan"] = "greaterthan";
    ConditionalOperations["greaterThanOrEqual"] = "greaterthanorequal";
    ConditionalOperations["lessThan"] = "lessthan";
    ConditionalOperations["lessThanOrEqual"] = "lessthanorequal";
    ConditionalOperations["between"] = "between";
    ConditionalOperations["beginsWith"] = "beginswith";
    ConditionalOperations["endsWith"] = "endswith";
    ConditionalOperations["contains"] = "contains";
    ConditionalOperations["doesNotContain"] = "doesnotcontain";
    ConditionalOperations["not"] = "not";
    ConditionalOperations["and"] = "and";
    ConditionalOperations["or"] = "or";
    ConditionalOperations["xor"] = "xor";
})(ConditionalOperations = exports.ConditionalOperations || (exports.ConditionalOperations = {}));
var DataOperatorType;
(function (DataOperatorType) {
    DataOperatorType["logicOperator"] = "logic";
    DataOperatorType["eventOperator"] = "event";
    DataOperatorType["valueOperator"] = "value";
})(DataOperatorType = exports.DataOperatorType || (exports.DataOperatorType = {}));
var EventOpConditionalField;
(function (EventOpConditionalField) {
    EventOpConditionalField["asnSentDate"] = "asnsentdate";
    EventOpConditionalField["earliestShipDateTime"] = "earliestshipdatetime";
    EventOpConditionalField["createDate"] = "createdate";
    EventOpConditionalField["confirmDate"] = "confirmdate";
    EventOpConditionalField["endOfDayRequestDate"] = "endofdayrequestdate";
    EventOpConditionalField["itemClassification"] = "itemclassification";
    EventOpConditionalField["countryOfOrigin"] = "countryoforigin";
    EventOpConditionalField["hazardousMaterial"] = "hazardousmaterial";
    EventOpConditionalField["moveableUnit"] = "moveableunit";
    EventOpConditionalField["hazardousMaterialFlag"] = "hazardousmaterialflag";
    EventOpConditionalField["capacityType"] = "capacitytype";
    EventOpConditionalField["createSource"] = "createsource";
    EventOpConditionalField["retailerId"] = "retailerid";
    EventOpConditionalField["shipService"] = "shipservice";
    EventOpConditionalField["warehouse"] = "warehouse";
    EventOpConditionalField["totalPrimaryQty"] = "totalprimaryqty";
    EventOpConditionalField["totalSecondaryQty"] = "totalsecondaryqty";
    EventOpConditionalField["primaryQty"] = "primaryqty";
    EventOpConditionalField["secondaryQty"] = "secondaryqty";
    EventOpConditionalField["discountAmount"] = "discountamount";
    EventOpConditionalField["subtotal"] = "subtotal";
    EventOpConditionalField["tax"] = "tax";
    EventOpConditionalField["weightlb"] = "weightlb";
    EventOpConditionalField["weightkg"] = "weightkg";
    EventOpConditionalField["totalMus"] = "totalmus";
    EventOpConditionalField["carrier"] = "carrier";
    EventOpConditionalField["lotNumber"] = "lotnumber";
    EventOpConditionalField["qualifier"] = "qualifier";
    EventOpConditionalField["shipToCompany"] = "shiptocompany";
    EventOpConditionalField["shipToState"] = "shiptostate";
    EventOpConditionalField["shipToCountry"] = "shiptocountry";
    EventOpConditionalField["class"] = "class";
    EventOpConditionalField["expectedArrivalDate"] = "expectedarrivaldate";
    EventOpConditionalField["muType"] = "mutype";
    EventOpConditionalField["primaryUntis"] = "primaryuntis";
    EventOpConditionalField["secondaryUnits"] = "secondaryunits";
    EventOpConditionalField["supplier"] = "supplier";
    EventOpConditionalField["landedCost"] = "landedcost";
    EventOpConditionalField["numberOfPalletized"] = "numberofpalletized";
    EventOpConditionalField["totalVolume"] = "totalvolume";
    EventOpConditionalField["totalWeight"] = "totalweight";
    EventOpConditionalField["volume"] = "volume";
    EventOpConditionalField["numberOfPackagedUnits"] = "numberofpackagedunits";
    EventOpConditionalField["qty"] = "qty";
    EventOpConditionalField["totalQty"] = "totalqty";
    EventOpConditionalField["baseQty"] = "baseqty";
    EventOpConditionalField["transactionEntryType"] = "transactionentrytype";
    EventOpConditionalField["referenceNumber"] = "referencenumber";
    EventOpConditionalField["sku"] = "sku";
    EventOpConditionalField["fulfillmentTime"] = "fulfillmenttime";
    EventOpConditionalField["poNumber"] = "ponumber";
})(EventOpConditionalField = exports.EventOpConditionalField || (exports.EventOpConditionalField = {}));
class IDataOperator {
    opType;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(DataOperatorType) })
], IDataOperator.prototype, "opType", void 0);
exports.IDataOperator = IDataOperator;
class ILogicOperator extends IDataOperator {
    operation;
    operands;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(ConditionalOperations) })
], ILogicOperator.prototype, "operation", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'array',
        items: {
            oneOf: [
                (0, openapi_1.ref)(() => IEventOperator),
                (0, openapi_1.ref)(() => IValueOperator),
                (0, openapi_1.ref)(() => ILogicOperator),
            ],
        },
    })
], ILogicOperator.prototype, "operands", void 0);
exports.ILogicOperator = ILogicOperator;
class IEventOperator extends IDataOperator {
    conditionalField;
    jsonpath;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(EventOpConditionalField) })
], IEventOperator.prototype, "conditionalField", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IEventOperator.prototype, "jsonpath", void 0);
exports.IEventOperator = IEventOperator;
class IDateContext {
    type;
}
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        enum: ['datetime', 'dayofmonth', 'dayofweek', 'timeofday'],
    })
], IDateContext.prototype, "type", void 0);
exports.IDateContext = IDateContext;
class ICarrierContext {
    type;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: ['select', 'input', 'combined'] })
], ICarrierContext.prototype, "type", void 0);
exports.ICarrierContext = ICarrierContext;
class IValueOperator extends IDataOperator {
    dataType;
    displayType;
    value;
    context;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: ['string', 'number', 'boolean', 'tuple'] })
], IValueOperator.prototype, "dataType", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        enum: [
            'string',
            'number',
            'boolean',
            'datetime',
            'list<strings>',
            'list<numbers>',
            'carrier',
        ],
    })
], IValueOperator.prototype, "displayType", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IValueOperator.prototype, "value", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ oneOf: [(0, openapi_1.ref)(() => IDateContext), (0, openapi_1.ref)(() => ICarrierContext)] })
], IValueOperator.prototype, "context", void 0);
exports.IValueOperator = IValueOperator;
class ICondition {
    condition;
    chargeMethod;
    uomChargeMethod;
    chargeTiers;
}
__decorate([
    (0, openapi_1.Schema)(() => ILogicOperator)
], ICondition.prototype, "condition", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IChargeMethod_1.IChargeMethod)
], ICondition.prototype, "chargeMethod", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IUomChargeMethod_1.IUomChargeMethod)
], ICondition.prototype, "uomChargeMethod", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IChargeTier_1.IChargeTiers)
], ICondition.prototype, "chargeTiers", void 0);
exports.ICondition = ICondition;
